import _ from 'lodash';
import { TEMP_ARRAY } from '../constants/nlpSettings';

const isQueryRelevantToHotel = (relevantTerms) => (rawQuery) => {
  const HOTEL_RELEVANT_TERMS = relevantTerms ? relevantTerms.HOTEL_RELEVANT_TERMS : TEMP_ARRAY;
  const query = rawQuery.toLowerCase();
  return _.some(HOTEL_RELEVANT_TERMS, (term) => query.includes(term));
};

const isQueryRelevantToCruise = (relevantTerms) => (rawQuery) => {
  const CRUISE_RELEVANT_TERMS = relevantTerms ? relevantTerms.CRUISE_RELEVANT_TERMS : TEMP_ARRAY;
  const query = rawQuery.toLowerCase();
  return _.some(CRUISE_RELEVANT_TERMS, (term) => query.includes(term));
};

export { isQueryRelevantToHotel, isQueryRelevantToCruise };
